import { debounce } from 'lodash';
import { useEffect, useMemo, useRef } from 'react';

export function useMapheimDebounced<T, K>(func: (args: T) => K, delay: number) {
    const saveRef = useRef(func);
    useEffect(() => {
        saveRef.current = func;
    }, [func]);

    const fnDebounced = useMemo(() => {
        const func = (input?: T) => {
            saveRef.current(input);
        };
        return debounce(func, delay);
    }, []);

    return fnDebounced;
}
